export const fontAssets = {
    "Inter": {
        "normal": "/fonts/Inter/static/Inter_18pt-Regular.ttf",
        "bold": "/fonts/Inter/static/Inter_18pt-Bold.ttf",
        "italic": "/fonts/Inter/static/Inter_18pt-Italic.ttf",
        "bolditalic": "/fonts/Inter/static/Inter_18pt-BoldItalic.ttf"
    },
    "Roboto": {
        "normal": "/fonts/Roboto/static/Roboto-Regular.ttf",
        "bold": "/fonts/Roboto/static/Roboto-Bold.ttf",
        "italic": "/fonts/Roboto/static/Roboto-Italic.ttf",
        "bolditalic": "/fonts/Roboto/static/Roboto-BoldItalic.ttf"
    },
    "Open Sans": {
        "normal": "/fonts/Open_Sans/static/OpenSans-Regular.ttf",
        "bold": "/fonts/Open_Sans/static/OpenSans-Bold.ttf",
        "italic": "/fonts/Open_Sans/static/OpenSans-Italic.ttf",
        "bolditalic": "/fonts/Open_Sans/static/OpenSans-BoldItalic.ttf"
    },
    "Montserrat": {
        "normal": "/fonts/Montserrat/static/Montserrat-Regular.ttf",
        "bold": "/fonts/Montserrat/static/Montserrat-Bold.ttf",
        "italic": "/fonts/Montserrat/static/Montserrat-Italic.ttf",
        "bolditalic": "/fonts/Montserrat/static/Montserrat-BoldItalic.ttf"
    },
    "Lato": {
        "normal": "/fonts/Lato/Lato-Regular.ttf",
        "bold": "/fonts/Lato/Lato-Bold.ttf",
        "italic": "/fonts/Lato/Lato-Italic.ttf",
        "bolditalic": "/fonts/Lato/Lato-BoldItalic.ttf"
    },
    "Poppins": {
        "normal": "/fonts/Poppins/Poppins-Regular.ttf",
        "bold": "/fonts/Poppins/Poppins-Bold.ttf",
        "italic": "/fonts/Poppins/Poppins-Italic.ttf",
        "bolditalic": "/fonts/Poppins/Poppins-BoldItalic.ttf"
    },
    "Oswald": {
        "normal": "/fonts/Oswald/static/Oswald-Regular.ttf",
        "bold": "/fonts/Oswald/static/Oswald-Bold.ttf",
        "italic": "/fonts/Oswald/static/Oswald-Italic.ttf",
        "bolditalic": "/fonts/Oswald/static/Oswald-BoldItalic.ttf"
    },
    "Playfair Display": {
        "normal": "/fonts/Playfair_Display/static/PlayfairDisplay-Regular.ttf",
        "bold": "/fonts/Playfair_Display/static/PlayfairDisplay-Bold.ttf",
        "italic": "/fonts/Playfair_Display/static/PlayfairDisplay-Italic.ttf",
        "bolditalic": "/fonts/Playfair_Display/static/PlayfairDisplay-BoldItalic.ttf"
    },
    "Calibri": {
        "normal": "/fonts/Calibri/calibri.ttf",
        "bold": "/fonts/Calibri/calibrib.ttf",
        "italic": "/fonts/Calibri/calibrii.ttf",
        "bolditalic": "/fonts/Calibri/calibriz.ttf"
    },
    "Verdana": {
        "normal": "/fonts/Verdana/Verdana.ttf",
        "bold": "/fonts/Verdana/Verdana-Bold.ttf",
        "italic": "/fonts/Verdana/Verdana-Italic.ttf",
        "bolditalic": "/fonts/Verdana/Verdana-BoldItalic.ttf"
    },
    "Georgia": {
        "normal": "/fonts/Georgia/Georgia-Regular.ttf",
        "bold": "/fonts/Georgia/Georgia-Bold.ttf",
        "italic": "/fonts/Georgia/Georgia-Italic.ttf",
        "bolditalic": "/fonts/Georgia/Georgia-BoldItalic.ttf"
    },
    "Manrope": {
        "normal": "/fonts/Manrope/static/Manrope-Regular.ttf",
        "bold": "/fonts/Manrope/static/Manrope-Bold.ttf",
        "italic": "/fonts/Manrope/static/Manrope-Regular.ttf",
        "bolditalic": "/fonts/Manrope/static/Manrope-Bold.ttf"
    },
    "Urbanist": {
        "normal": "/fonts/Urbanist/static/Urbanist-Regular.ttf",
        "bold": "/fonts/Urbanist/static/Urbanist-Bold.ttf",
        "italic": "/fonts/Urbanist/static/Urbanist-Italic.ttf",
        "bolditalic": "/fonts/Urbanist/static/Urbanist-BoldItalic.ttf"
    },
    "Satoshi": {
        "normal": "/fonts/Satoshi/Satoshi-Regular.ttf",
        "bold": "/fonts/Satoshi/Satoshi-Bold.ttf",
        "italic": "/fonts/Satoshi/Satoshi-Italic.ttf",
        "bolditalic": "/fonts/Satoshi/Satoshi-BoldItalic.ttf"
    },
    "Garamond": {
        "normal": "/fonts/Garamond/static/EBGaramond-Regular.ttf",
        "bold": "/fonts/Garamond/static/EBGaramond-Bold.ttf",
        "italic": "/fonts/Garamond/static/EBGaramond-Italic.ttf",
        "bolditalic": "/fonts/Garamond/static/EBGaramond-BoldItalic.ttf"
    },
    "Italic": {
        "normal": "/fonts/Italic/Italic-Regular.ttf",
        "bold": "/fonts/Italic/Italic-Bold.ttf",
        "italic": "/fonts/Italic/Italic-Italic.ttf",
        "bolditalic": "/fonts/Italic/Italic-BoldItalic.ttf"
    },
};
